/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons"
import { refreshPage, removeUserSession } from "../../Helpers/Utils/Common"
import { getName, getType, getRole } from "../../Helpers/Utils/Common"
import MenuItem from "./MenuItem"
import { logoutUser } from "../../Helpers/apiCalls/authApi"
import { toastStyle } from "../../Helpers/Utils/Common"

import toast from "react-hot-toast"

//css
import "../Navbar/Navbar.css"

//icons
import logout from "../../Assets/Images/Navbar/logout.png"
import logo from "../../Assets/Images/Login/mytlogo1.png"
import supplies from "../../Assets/Images/Navbar/supplies.png"
import sales from "../../Assets/Images/Navbar/sales.png"
import cp from "../../Assets/Images/Navbar/cp.png"
import reports from "../../Assets/Images/Navbar/reports.png"
import storeReport from "../../Assets/Images/Navbar/storeReport.png"
import manage from "../../Assets/Images/Navbar/manage.png"
import employee from "../../Assets/Images/Navbar/employee.png"
import pettycashicon from "../../Assets/Images/Navbar/pettycash.png"
import expenseReport from "../../Assets/Images/Navbar/expenseReport.png"
import bank_transfer from "../../Assets/Images/Navbar/bank_transfer.png"

const Navbar = (props) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  //ADMIN
  const adminMenu = [
    {
      name: "DASHBOARD",
      exact: true,
      to: "/dashboard",
      iconClassName: cp,
      expand: true,
    },
    {
      name: "SALES",
      exact: true,
      to: "/",
      iconClassName: sales,
      subMenus: [
        { name: "Project Register", to: "/project" },
        { name: "Project Sales Invoice", to: "/projectinvoice" },
        { name: "Project Change Request", to: "/projectchangerequest" },
        // { name: "Distributor Billings", to: "/distributor_billings" },
        // { name: "Subscription Billings", to: "/subscription_billings" },
      ],
      expand: true,
    },
    {
      name: "EXPENSE",
      exact: true,
      to: "/",
      iconClassName: supplies,
      subMenus: [
        { name: "Purchase Order", to: "/suppliesexpenses" },
        // {
        //   name: "Supplies Invoice",
        //   to: "/se/purchaseinvoices",
        // },
        { name: "Project Expense", to: "/projectexpense" },
        { name: "Pay supplier", to: "/se/paysuppliers" },
      ],
      expand: true,
    },
    {
      name: "PETTY CASH",
      exact: true,
      to: "/pettycash", // Updated route
      iconClassName: pettycashicon,
      expand: false, // Removed submenu behavior
    },
    {
      name: "TRANSFER",
      exact: true,
      to: "/transaction",
      iconClassName: bank_transfer,
      expand: false,
    },

    // {
    //   name: "SALES REPORT",
    //   exact: true,
    //   to: "/",
    //   iconClassName: reports,
    //   subMenus: [
    //   ],
    //   expand: true,
    // },

    // {
    //   name: "EXPENSES REPORT",
    //   exact: true,
    //   to: "/",
    //   iconClassName: expenseReport,
    //   subMenus: [
    //     // { name: "Payables Aging Report", to: "/payablesagingreport" },
    //     // { name: "Expense By Date", to: "/expensebydate" }
    //   ],
    //   expand: true,
    // },
    {
      name: "FINANCIAL REPORT",
      exact: true,
      to: "/",
      iconClassName: storeReport,
      subMenus: [
        { name: "Project Sales", to: "/projectsales" },
        { name: "Income Statement", to: "/incomestatementreport" },
        { name: "Accounts Receivable", to: "/receivablesagingreport" },
        { name: "Statement of Account", to: "/statement-of-account" },
        { name: "Operating Expenses", to: "/expensebytype" },
        { name: "Customer Payments", to: "/salesreport" },
        { name: "Supplier Payments", to: "/supplierspayment" },
        { name: "Journal Entry", to: "/journalentryreport" },
        { name: "Bank Reconciliation", to: "/bank-reconciliation" },
      ],
      expand: true,
    },
    {
      name: "MANAGE",
      exact: true,
      to: "/",
      iconClassName: manage,
      subMenus: [
        { name: "Suppliers", to: "/suppliers" },
        { name: "Banks", to: "/banks" },
        { name: "Credit Cards", to: "/credit-cards"},
        { name: "Customer", to: "/customer" },
        /*{ name: "Forwarders", to: "/forwarders" },*/
        { name: "Account Type ", to: "/expensetypes" },
        { name: "Users", to: "/users" },
        { name: "Distributors", to: "/distributors" },
      ],
      expand: true,
    },
  ]

  const liasonOfficerMenu = [
    {
      name: "PETTY CASH",
      exact: true,
      to: "/pettycash", // Updated route
      iconClassName: pettycashicon,
      expand: false, // Removed submenu behavior
    },
    {
      name: "TRANSFER",
      exact: true,
      to: "/transaction",
      iconClassName: bank_transfer,
      expand: false,
    },
  ]

  const financeAccountingOfficerMenu = [
    {
      name: "EXPENSE",
      exact: true,
      to: "/",
      iconClassName: supplies,
      subMenus: [
        { name: "Purchase Order", to: "/suppliesexpenses" },
        { name: "Project Expense", to: "/projectexpense" },
        { name: "Pay supplier", to: "/se/paysuppliers" },
      ],
      expand: true,
    },
    {
      name: "TRANSFER",
      exact: true,
      to: "/transaction",
      iconClassName: bank_transfer,
      expand: false,
    },
  ]

  const projectManagerMenu = [
    {
      name: "SALES",
      exact: true,
      to: "/",
      iconClassName: sales,
      subMenus: [
        { name: "Project Register", to: "/project" },
        { name: "Project Change Request", to: "/projectchangerequest" },
      ],
      expand: true,
    },
        {
      name: "MANAGE",
      exact: true,
      to: "/",
      iconClassName: manage,
      subMenus: [
        { name: "Customer", to: "/customer" },
      ],
      expand: true,
    },
  ]

  // logout handler
  async function handleLogout() {
    const response = await logoutUser()
    removeUserSession()
    window.localStorage.clear()
    toast.success("Logging you out...", {
      style: toastStyle(),
    })
    setTimeout(() => refreshPage(), 1000)
  }

  const [inactive, setInactive] = useState(false)
  const [menuItems, setMenuItems] = useState([])
  const [expandManage, setExpandManage] = useState(true)

  // Check if device is mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  // Close mobile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (mobileMenuOpen && !event.target.closest('.side-menu') && !event.target.closest('.mobile-hamburger-btn')) {
        setMobileMenuOpen(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [mobileMenuOpen])

  // Initialize inactive state based on mobile detection
  useEffect(() => {
    setInactive(isMobile ? false : true)
  }, [isMobile])

  const handleExpand = (index) => {
    var list = [...menuItems]

    if (!inactive) {
      for (var i = 0; i < list.length; i++) {
        if (i !== index) {
          list[i]["expand"] = true
        }
      }

      list[index]["expand"] = !list[index]["expand"]

      setMenuItems(list)
    }
  }

  useEffect(() => {
    // Ensure mobile navigation is never inactive
    if (isMobile && inactive) {
      setInactive(false)
    }

    if (inactive) {
      removeActiveClassFromSubMenu()
    }

    // Only call onCollapse for desktop navigation
    if (!isMobile && props.onCollapse) {
      props.onCollapse(inactive)
    }
  }, [inactive, isMobile])

  const removeActiveClassFromSubMenu = () => {
    document.querySelectorAll(".sub-menu").forEach((el) => {
      el.classList.remove("active")
    })
  }

  useEffect(() => {
    const type = getType()
    switch (type) {
      case "admin":
        setMenuItems(adminMenu)
        break
      case "liason_officer":
        setMenuItems(liasonOfficerMenu)
        break
      case "finance_accounting_officer":
        setMenuItems(financeAccountingOfficerMenu)
        break
      case "project_manager":
        setMenuItems(projectManagerMenu)
        break
      default:
        break
    }
  }, [])

  useEffect(() => {
    if (menuItems.length > 0) {
      let menuItemsList = document.querySelectorAll(".menu-item")
      menuItemsList.forEach((el, index) => {
        if (menuItems[index] && menuItems[index].name == props.active) {
          el.classList.add("active")
        }
        el.addEventListener("click", (e) => {
          const next = el.nextElementSibling
          removeActiveClassFromSubMenu()
          menuItemsList.forEach((el) => el.classList.remove("active"))
          el.classList.toggle("active")
          if (next !== null) {
            next.classList.toggle("active")
          }
        })
      })
    }
  }, [menuItems, props.active])

  return (
    <>
      {/* Mobile Hamburger Menu */}
      {isMobile && (
        <div className="mobile-hamburger-container">
          <button
            className="mobile-hamburger-btn"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            <FontAwesomeIcon icon={mobileMenuOpen ? faTimes : faBars} />
          </button>
        </div>
      )}

      {/* Mobile Navigation Overlay */}
      {isMobile && mobileMenuOpen && (
        <div className="mobile-nav-overlay" onClick={() => setMobileMenuOpen(false)}>
          <div className="mobile-nav-content" onClick={(e) => e.stopPropagation()}>
            <div className={`side-menu mobile-nav`}>
              <div className="top-section">
                <div className="logo d-flex justify-content-center">
                  <img
                    src={logo}
                    className="navbar-logo"
                  />
                </div>
              </div>

              <div className="main-menu active-menu">
                {menuItems && menuItems.length > 0 && menuItems.map((menuItem, index) => (
                  <MenuItem
                    key={index}
                    name={menuItem.name}
                    exact={menuItem.exact.toString()}
                    to={menuItem.to}
                    subMenus={menuItem.subMenus || []}
                    iconClassName={menuItem.iconClassName}
                    expandManage={menuItem.expand}
                    setExpandManage={handleExpand}
                    index={index}
                    activeSub={menuItem.name === props.active}
                    isMobile={true}
                    onMobileMenuClose={() => setMobileMenuOpen(false)}
                    onClick={() => {
                      if (inactive) {
                        setInactive(false)
                      }
                    }}
                  />
                ))}
              </div>
              <div className="side-menu-footer">
                <div className="user-details-footer">
                  <span className="navbar-user-label">{getName()}</span>
                  <br />
                  <span className="user-type-label">{getType()}</span>
                </div>
                <div className="logout-cont" onClick={() => handleLogout()}>
                  <img src={logout} className="logout-btn" />
                  <span className="logout-label">LOGOUT</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Desktop Navigation */}
      {!isMobile && (
        <div className={`side-menu ${inactive ? "inactive" : ""}`}>
          <div className="top-section">
            <div className="logo d-flex justify-content-center">
              <img
                src={logo}
                className="navbar-logo"
                onClick={() => setInactive(!inactive)}
              />
            </div>
          </div>

          <div className={inactive ? "main-menu" : "main-menu active-menu"}>
            {menuItems && menuItems.length > 0 && menuItems.map((menuItem, index) => (
              <MenuItem
                key={index}
                name={menuItem.name}
                exact={menuItem.exact.toString()}
                to={menuItem.to}
                subMenus={menuItem.subMenus || []}
                iconClassName={menuItem.iconClassName}
                expandManage={menuItem.expand}
                setExpandManage={handleExpand}
                index={index}
                activeSub={menuItem.name === props.active}
                isMobile={false}
                onMobileMenuClose={undefined}
                onClick={() => {
                  if (inactive) {
                    setInactive(false)
                  }
                }}
              />
            ))}
          </div>
          <div className="side-menu-footer">
            {!inactive && (
              <div className="user-details-footer">
                <span className="navbar-user-label">{getName()}</span>
                <br />
                <span className="user-type-label">{getType()}</span>
              </div>
            )}
            <div className="logout-cont" onClick={() => handleLogout()}>
              <img src={logout} className="logout-btn" />
              <span className="logout-label">LOGOUT</span>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Navbar
